import { EncounterActionSelectionQueryMap } from '../components/actions/encounterActionSelection'
import { EncounterDetailTabQueryMap } from '../components/EncounterTabs'
import { EncounterAgentSessionQueryMap } from '../hooks/useAgentSessionTabs'
import { EncounterSidebarQueryMap } from '../hooks/useEncounterSidebarTabs'
import { EncounterWorkBlockHistoryQueryMap } from '../../work-blocks/utils/encounterWorkBlockHistoryQuery'
import type { inferParserType } from 'nuqs'
import {
  createSerializer,
  parseAsBoolean,
  parseAsString,
  useQueryStates,
} from 'nuqs'
import { parseAsUuid } from '@joyful/utils'

export const EncounterBrowserSpecialistViewQueryMap = {
  browser_task_id: parseAsUuid,
}

export const EncounterRouteQueryParamMap = {
  ...EncounterActionSelectionQueryMap,
  ...EncounterSidebarQueryMap,
  ...EncounterAgentSessionQueryMap,
  ...EncounterDetailTabQueryMap,
  ...EncounterBrowserSpecialistViewQueryMap,
  ...EncounterWorkBlockHistoryQueryMap,
  attachment: parseAsString,
  packet_id: parseAsUuid,
  prevent_redirect: parseAsBoolean.withDefault(false),
  redirected_from: parseAsUuid,
}

export type EncounterRouteQueryParams = inferParserType<
  typeof EncounterRouteQueryParamMap
>

export const serializeEncounterRouteQueryParams = createSerializer(
  EncounterRouteQueryParamMap,
)

export function useEncounterBrowserSpecialistViewQueryParams() {
  return useQueryStates(EncounterBrowserSpecialistViewQueryMap, {
    history: 'push',
  })
}
